
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenReport {

    id: number;
    active: boolean;
    attributionTitle: string;
    attributionUrl: string;
    description: string;
    displayName: string;
    ordering: number;
    params: string;
    reportGroupId: number;
    serviceUrl: string;
    uiHandle: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genReport: GenReport);
    constructor( id: number );

    constructor( input?: GenReport|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.active = input.active; // boolean [boolean]
            this.attributionTitle = input.attributionTitle; // string [string]
            this.attributionUrl = input.attributionUrl; // string [string]
            this.description = input.description; // string [string]
            this.displayName = input.displayName; // string [string]
            this.ordering = input.ordering; // int [number]
            this.params = input.params; // string [string]
            this.reportGroupId = input.reportGroupId; // int [number]
            this.serviceUrl = input.serviceUrl; // string [string]
            this.uiHandle = input.uiHandle; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenReport[] {
        if (arr && arr.map) {
          return arr.map(a => new GenReport(a));
        } else {
          return [];
        }
    }
}

